import React from "react";
import LeftTestConsole from "./LeftTestConsole";
import MiddleTestConsole from "./MiddleTestConsole";
import "../styles/testconsole.css";


const DesktopConsole = ({
  quesData,
  catName,
  type,
  testId,

  MyTimer,
  time,
  timeExpired,
  rankArray,

  curQues,
  ansArray,
  visitedArr,
onSubmitClick,
  setAnswer,
  nextQues,
  preQues,
  clearResponse,
  setQues
}) => {
   console.log("DesktopConsole", onSubmitClick);
  return (
    <div className="tc-grid desktop-console">
      <aside className="tc-left">
       
        <LeftTestConsole
        
          setQues={setQues}
          ansArray={ansArray}
          catName={catName}
          quesData={quesData}
          type={type}
          testId={testId}
          curQues={curQues}
          visitedArr={visitedArr}
          MyTimer={MyTimer}
          time={time}
          timeExpired={timeExpired}
          rankArray={rankArray}
          onSubmitClick={onSubmitClick}

        />
      </aside>

      <main className="tc-middle">
        <MiddleTestConsole
          questions={quesData}
          curQues={curQues}
          nextQues={nextQues}
          preQues={preQues}
          clearResponse={clearResponse}
          setAnswer={setAnswer}
          ansArray={ansArray}
        />
      </main>

      {/* Future Right Panel */}
      {/*
      <aside className="tc-right">
          <RightTestConsole />
      </aside>
      */}
    </div>
  );
};

export default DesktopConsole;